var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8318 0.00634766C7.18347 0.00634766 0.171509 6.94509 0.171509 15.5031C0.171509 24.0611 7.18347 30.9998 15.8318 30.9998C24.4801 30.9998 31.492 24.0611 31.492 15.5031C31.492 6.94509 24.4801 0.00634766 15.8318 0.00634766ZM21.1745 8.91551H19.5973C18.0464 8.91551 17.5601 9.87146 17.5601 10.8469V13.1685H21.0234L20.4714 16.7387H17.5601V25.3747H13.6566V16.7387H10.4824V13.1685H13.6566V10.4437C13.6566 7.34828 15.5229 5.63798 18.375 5.63798C19.7419 5.63798 21.168 5.87859 21.168 5.87859V8.92202L21.1745 8.91551Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2baee6d94ad16bf0f72579f20294b658.svg";
export { ForwardRef as ReactComponent };